var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSomaliland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5759C31.6479 19.8426 32 17.9678 32 16.0107C32 14.0536 31.6479 12.1788 31.0048 10.4455L16 9.0542L0.995188 10.4455C0.352063 12.1788 0 14.0536 0 16.0107C0 17.9678 0.352063 19.8426 0.995188 21.5759L16 22.9672L31.0048 21.5759Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.8794 32.0107 28.7441 27.6687 31.0047 21.5759H0.995117C3.25587 27.6687 9.12049 32.0107 16 32.0107Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C9.12049 0.0107422 3.25587 4.35274 0.995117 10.4456H31.0048C28.7441 4.35274 22.8794 0.0107422 16 0.0107422Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5325L16.8633 15.1895H19.6573L17.397 16.8318L18.2604 19.489L16 17.8469L13.7396 19.489L14.6031 16.8318L12.3428 15.1895H15.1367L16 12.5325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7537 3.14111V6.38743C20.7537 6.89899 20.3376 7.31499 19.8262 7.31499V8.7063C21.1048 8.7063 22.145 7.66611 22.145 6.38743V3.14111H20.7537Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.783 6.38743C10.783 6.89899 10.367 7.31499 9.85547 7.31499V8.7063C11.1342 8.7063 12.1743 7.66611 12.1743 6.38743V3.14111H10.783V6.38743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6669 3.14111H20.0582V6.38743H18.6669V3.14111Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5801 4.99611C16.5801 5.12399 16.4761 5.22805 16.3482 5.22805C16.2204 5.22805 16.1163 5.12399 16.1163 4.99611V3.14111H14.725V4.99611C14.725 5.12399 14.621 5.22805 14.4931 5.22805C14.3652 5.22805 14.2612 5.12399 14.2612 4.99611V3.14111H12.8699V4.99611C12.8699 5.89124 13.5981 6.61936 14.4931 6.61936C14.8378 6.61936 15.1576 6.51105 15.4206 6.32711C15.6838 6.51105 16.0035 6.61936 16.3482 6.61936C16.4176 6.61936 16.4859 6.61449 16.553 6.60593C16.4544 7.01211 16.0886 7.31499 15.6526 7.31499V8.7063C16.9312 8.7063 17.9714 7.66611 17.9714 6.38743V4.99611V3.14111H16.5801L16.5801 4.99611Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 7.31494H14.9569V8.70625H12.87V7.31494Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSomaliland);
export default __webpack_public_path__ + "static/media/flag_somaliland.0a2536576a672e411eb7315c82e55cec.svg";
export { ForwardRef as ReactComponent };